import { useState } from 'react'

import { Viewport } from './accountModel'
import { AccountShell } from './AccountShell'
import { AgentAvatar } from './AgentAvatar'
import { AgentChatModal } from './AgentChatModal'
import { BottomNav } from './BottomNav'

interface MusePlacementProps {
  viewport: Viewport
  /** Bumped each time the prototype's trigger fires; 0 means nothing sent yet. */
  notificationId: number
  className?: string
}

/**
 * Option 1 wired up: the avatar in the top bar opens the panel docked bottom
 * right. Holds the open state here rather than in `AccountShell`, so the shell
 * stays a neutral set of slots that every other option can arrange differently.
 */
export function MusePlacement({ viewport, notificationId, className }: MusePlacementProps) {
  const [open, setOpen] = useState(false)
  // Tracked per view, so opening the chat in one pane does not clear the dot in another.
  const [readId, setReadId] = useState(0)
  const unread = notificationId > readId

  function toggle() {
    // Opening is the read: the message is on screen the moment the panel is.
    if (!open) setReadId(notificationId)
    setOpen((was) => !was)
  }

  return (
    <AccountShell
      viewport={viewport}
      topNavCenter={<AgentAvatar active={open} unread={unread} onClick={toggle} />}
      overlay={open && <AgentChatModal onClose={() => setOpen(false)} notified={notificationId > 0} />}
      bottomNav={<BottomNav onToggle={toggle} active={open} />}
      className={className}
    />
  )
}
